import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { useId } from "react";
import { useProps } from "./auth-service-tools225.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { useComboboxContext } from "./auth-service-tools332.js";
import classes from "./auth-service-tools330.js";
const defaultProps = {};
const ComboboxOption = factory((_props, ref) => {
  const props = useProps("ComboboxOption", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    vars,
    onClick,
    id,
    active,
    onMouseDown,
    onMouseOver,
    disabled,
    selected,
    mod,
    ...others
  } = props;
  const ctx = useComboboxContext();
  const uuid = useId();

  const _id = id || uuid;

  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, { ...ctx.getStyles("option", {
      className,
      classNames,
      styles,
      style
    }),
    ...others,
    ref,
    id: _id,
    mod: ["combobox-option", {
      "combobox-active": active,
      "combobox-disabled": disabled,
      "combobox-selected": selected
    }, mod],
    role: "option",
    onClick: event => {
      var _a;

      if (!disabled) {
        (_a = ctx.onOptionSubmit) == null ? void 0 : _a.call(ctx, props.value, props);
        onClick == null ? void 0 : onClick(event);
      } else {
        event.preventDefault();
      }
    },
    onMouseDown: event => {
      event.preventDefault();
      onMouseDown == null ? void 0 : onMouseDown(event);
    },
    onMouseOver: event => {
      if (ctx.resetSelectionOnOptionHover) {
        ctx.store.resetSelectedOption();
      }

      onMouseOver == null ? void 0 : onMouseOver(event);
    }
  });
});
ComboboxOption.classes = classes;
ComboboxOption.displayName = "@mantine/core/ComboboxOption";
export { ComboboxOption };